import Icon from '../components/Icon.vue'

Icon.register({
  'grin-hearts': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM90.4 183.6C97.1 166 117.1 156.9 135.3 161.7L142.4 163.6 144.4 156.5C149.4 138.4 167.2 125.6 185.9 128.6 207.3 132 220.3 152.8 214.7 173.1L195.3 243C194.1 247.5 189.4 250.2 184.8 249L114.6 230.8C94.2 225.4 82.7 203.8 90.4 183.6zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.9 113.4 317.2 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.5 317.2 393.7 326.9 391.8 338.7 382.5 393.7 308.6 432 248 432zM381.4 230.7L311.2 248.9C306.7 250.1 302 247.4 300.7 242.9L281.3 173C275.7 152.7 288.7 131.9 310.1 128.5 328.7 125.5 346.5 138.3 351.6 156.4L353.6 163.5 360.7 161.6C378.9 156.9 398.9 165.9 405.6 183.5 413.3 203.8 401.8 225.4 381.4 230.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-hearts.js
// module id = EFmB
// module chunks = 144